import { createFileRoute } from "@tanstack/react-router";

import { InhaltePflege } from "@/components/inhalte-pflege";

function ManagementInhaltePage() {
  return <InhaltePflege />;
}

export const Route = createFileRoute("/_app/management/inhalte")({
  component: ManagementInhaltePage,
});
